import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * Final storytelling CTA — Deep Navy background, large gold button.
 * Sits near the bottom of the storefront home just before the second product row.
 */
const FinalCTA = () => {
  return (
    <section className="relative overflow-hidden gradient-navy text-white" data-testid="home-final-cta">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 30% 30%, rgba(212,166,58,0.5), transparent 55%), radial-gradient(circle at 78% 78%, rgba(126,151,113,0.25), transparent 55%)',
      }} />
      <div className="relative max-w-[900px] mx-auto px-6 lg:px-10 py-24 md:py-32 text-center">
        <div className="text-[11px] uppercase tracking-[0.3em] text-brand-gold mb-6">Purpose with Hope</div>
        <h3 className="font-serif-display text-4xl md:text-6xl leading-tight text-white">
          Every purchase creates opportunity.<br />
          <span className="italic text-brand-gold">Every gift carries hope.</span>
        </h3>
        <p className="mt-6 text-white/75 max-w-xl mx-auto">
          Wear something meaningful. Gift something eternal. Every product carries a story of redemption.
        </p>
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/shop"
            className="inline-flex items-center gap-3 bg-brand-gold hover:bg-brand-gold-2 text-brand-navy font-semibold px-9 py-5 rounded-full text-xs uppercase tracking-[0.3em] transition-colors duration-500 shadow-2xl shadow-brand-gold/30"
            data-testid="home-cta-shop"
          >
            Shop with Purpose <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/about"
            className="border border-white/40 hover:border-brand-gold text-white hover:text-brand-gold px-9 py-5 rounded-full text-xs uppercase tracking-[0.3em] transition-colors"
          >
            Read Our Story
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
